import React from 'react';

import {useGeneralProvider} from 'brand/app/components/_app-config/GeneralProvider';
import Button from 'brandComponents/Button';

import {ICTALoginProps} from './ICTALoginCta';

const CTALogin = ({title, targetUrl}: ICTALoginProps) => {
	const {managerRepository} = useGeneralProvider();

	return (
		<Button
			onClick={() => {
				managerRepository.getFlyoutsMgr().openFlyout('login', true);

				let currentUrl = new URL(window.location.href);

				if (targetUrl) {
					currentUrl.searchParams.set(targetUrl, 'true');

					window.history.pushState({}, '', currentUrl);
				}
			}}
			classNames="open-flyout"
			showAsLink
		>
			{title}
		</Button>
	);
};

export default CTALogin;
